/*
|--------------------------------------------------------------------------
| Views: Article Story Strip
|--------------------------------------------------------------------------
*/
/**
 * Article Story Strip
 * @namespace
 */
 
__gh__webApp.views.articleStoryStrip = {

	"callbacks": function(bucket){
		var articleDOM		= "#article";
		__gh__webApp.utilities.slider.loadAllSliders();
		__gh__webApp.articlePage.storyStrip.init(articleDOM);
		
	},


	"getSubView": function(bucket){

		//Update bucket
		bucket.view.name 					= "buckets/articleStoryStrip/default";
		bucket.view.sliderSettings 			= this.getSliderSettings(bucket.id);
		return bucket;
	},

/*  CODE FOR MOBILE STORY STACK 
	"getSubView": function(bucket){
        
        if (device.isPhone()){
            return __gh__webApp.views.articleStoryStack.getSubView(bucket);
        }
        
        //Update bucket
        bucket.view.name                    = "buckets/articleStoryStrip/default";
        bucket.view.sliderSettings          = this.getSliderSettings(bucket.id);
        return bucket;
    },  
*/
	"getSliderSettings":function(bucketID){
		var device 			= __gh__webApp.device,
			sliderSettings 	= {
			"infinite": true,
			"speed": 300,
			"slidesToShow": 1,
			"slidesToScroll": 1,
			"lazyLoad": "ondemand",
			"arrows":true,
			"dots":false,
			"draggable":true,
			"responsive": [
				{
					"breakpoint": 1200,
					"settings": {
						"slidesToShow": 5,
						"slidesToScroll": 5
					}
				},
				{
					"breakpoint": 992,
					"settings": {
						"slidesToShow": 3,
						"slidesToScroll": 3
					}
				},
				{
					"breakpoint": 480,
					"settings": {
						"slidesToShow": 2,
						"slidesToScroll": 2
					}
				},
				{
					"breakpoint": 420,
					"settings": {
						"slidesToShow": 1,
						"slidesToScroll": 1
					}
				}
			]
		};

		//mobile first breaks slider when it loads at phone size
		if (!device.isPhone()){
			sliderSettings.mobileFirst = true;
		}

		return sliderSettings;
	}

};
